import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "input", "wrapper"]

  replace(event) {
    event.preventDefault()
    
    // Hide the preview
    if (this.hasPreviewTarget) {
      this.previewTarget.style.display = "none"
    }
    
    // Show the file input wrapper
    if (this.hasWrapperTarget) {
      this.wrapperTarget.style.display = "block"
    }
    
    // Focus on the file input if available
    if (this.hasInputTarget) {
      this.inputTarget.click()
    }
  }

  cancel(event) {
    event.preventDefault()
    
    // Show the preview
    if (this.hasPreviewTarget) {
      this.previewTarget.style.display = "block"
    }
    
    // Hide the file input wrapper
    if (this.hasWrapperTarget) {
      this.wrapperTarget.style.display = "none"
    }
    
    // Clear the file input
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
  }
}